import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { PartShape } from '../../BaseShape/PartShape';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { MDAConstant } from '../../Base/MDAConstant';
import { MenuSet } from '../../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuSet';
import { MenuItem } from '../../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuItem';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { APPComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointMenuSetShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointMenuSetShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_MenuSet.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: MenuSet, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.menuItems, false);
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_MENUSET;
  }

  get menuSet(): MenuSet {
    return this.element() as MenuSet;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加菜单项
      case 'shape:addMenuItem':
        element = this.addMenuItem();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType !== '' && linkType !== MDAConstant.Link.ADD_MENUCONTAIN) {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  private addMenuItem(): MenuItem {
    const item = MDRepository.createMenuItem(this.menuSet);
    MDExtendService.setElementListSequence(this.menuSet.menuItems, true);
    this.model().compartments[0].push(item);
    return item;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: MenuItem = null;
    element = this.menuSet.menuItems.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.menuSet.menuItems.splice(this.menuSet.menuItems.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.isValid = false; // 删除的菜单设置为不启用，否则运行期已经存在的多余菜单会被显示
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(menuSet: MenuSet, isCollapse = false): ShapeModel {
    const model = new ShapeModel(menuSet, isCollapse);
    model.addCompartment(menuSet.menuItems.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointMenuSetShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new MenuSet();
    newElement.copyFrom(this.menuSet, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof APPComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.menuSets.push(newElement);
    }

    this.menuSet.menuItems.forEach(item => {
      const menuItem = new MenuItem();
      menuItem.copyFrom(item, false);
      MDExtendService.setCreateInfo(menuItem);
      menuItem.menuSet_ID = newElement.id;
      newElement.menuItems.push(menuItem);
      elements.push(menuItem);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): MenuItem | null {
    let newElement: MenuItem | null = null;
    if (element instanceof MenuItem) {
      newElement = new MenuItem();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.menuSet_ID = this.menuSet.id;
      this.menuSet.menuItems.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 菜单集
   *    - 必须包含至少一个主菜单集或菜单项
   * 2. 菜单集
   *    - 不能存在同名菜单项
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.menuSet.designId;
    MDValidation.validateBaseElement(this.menuSet, containerDesignId, true, errors);
    if (this.menuSet.menuItems.length === 0 && this.menuSet.mainMenuContains.length === 0) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `菜单集 [${this.menuSet.displayName}] 必须包含至少一个主菜单集或菜单项`));
    } else {
      this.menuSet.menuItems.forEach(element => {
        MDValidation.validateBaseElement(element, containerDesignId, true, errors);
        if (this.menuSet.menuItems.find(item => element.designId !== item.designId && element.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `菜单集 [${this.menuSet.displayName}] 不能存在同名菜单项 [${element.name}]`));
        }
      });
    }
    return errors;
  }
}
